import { render, staticRenderFns } from "./invoice-info.vue?vue&type=template&id=6bc6b0e6&scoped=true"
import script from "./invoice-info.vue?vue&type=script&lang=js"
export * from "./invoice-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6b0e6",
  null
  
)

export default component.exports